import { render, staticRenderFns } from "./ClassroomIndex.vue?vue&type=template&id=1e5e5969&scoped=true&"
import script from "./ClassroomIndex.vue?vue&type=script&lang=ts&"
export * from "./ClassroomIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomIndex.vue?vue&type=style&index=0&id=1e5e5969&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e5969",
  null
  
)

export default component.exports